module.exports = __webpack_public_path__ + "static/assets/68f336c32dc26c3b0c3c4ee043e6aa15.png";